import { getImg } from '@/utils/matchAsset'

export const matchDetailHeroData = {
  heroImage: getImg('match/pc/match/hero-bg.png'),
  heroImageWap: getImg('match/pc/match/mobile-home-hero-bg.jpg'),
  alt: '千年争霸赛',
}

export const matchDetailScheduleData = {
  titleImage: getImg('match/pc/match/detail-schedule-title.png'),
  timelineImage: getImg('match/pc/match/detail-schedule-timeline.png'),
}

export const matchDetailRulesSectionData = {
  titleImage: getImg('match/pc/match/detail-rules-title.png'),
  characterImage: getImg('match/pc/match/detail-rules-character.png'),
  signupLabelImage: getImg('match/pc/match/detail-rules-signup-label.png'),
  battleLabelImage: getImg('match/pc/match/detail-rules-battle-label.png'),
}

export const matchDetailScheduleList = [
  { id: 'qualifier-signup', title: '比赛报名', date: '8月20日/9月10日' },
  { id: 'sea-selection', title: '海选赛', date: '9月10日/9月26日' },
  { id: 'promotion', title: '晋级赛', date: '10月8日起每天一场' },
  { id: 'final', title: '总决赛', date: '10月30日' },
]

export const matchDetailRuleBlocks = [
  {
    id: 'signup-rule',
    title: '报名规则',
    content: [
      '首届千年争霸赛比赛共计32支参赛名额,先到先得,确定有效报名人数达到32支队伍将停止报名。',
      '1.报名地点：由团长联系官方赛事人员报名 报名地址：www.qn000.com  联系官方商务人员， 提供下述信息',
      '(1) 战队名：',
      '(2）战队游戏内马甲名：',
      '(3）队长联系方式：',
      '(4）战队指挥联系方式：',
      '',
      '2.每队固定50人编制，需自行组织50人参赛,官方统一配发50个专属比赛账号，仅限本次赛事使用',
      '3.全队统一自定义合规马甲，赛前审核，无马甲禁止参赛',
      '4.所有参赛队伍统一公开随机抽签分组，全程留档公示',
      '5.参赛流程联系商务报名——官方提供50个专属账号+赛事服地址至报名团长处——参赛队伍抽签分组——每队团长提前进入赛事服创建门派将队员加入门派——根据本队比赛日期组织成员参战！——海选赛3分晋级，0分淘汰，1积分和2积分的队伍进行再次随机对决，胜者晋级败者淘汰——海选赛16强胜者随机匹配进行8强争夺（胜者晋级败者淘汰无积分）——8强胜者进行4强对决——4强胜者进行进行冠亚军争夺，败者进行季军争夺——颁奖时刻！',
      '6.参赛门派创立后 禁止 退出门派，转移门主',
      '7.不足50人的参赛队伍 官方将进行队伍整合搭配 确保对战双方势均力敌。',
    ],
  },
  {
    id: 'battle-rule',
    title: '赛事对局规则(三局积分制)',
    content: [
      '一.海选赛三局积分制（32晋16）',
      '单轮对决共三局，单局胜利积1分、失败积0分;单场3分直接晋级;积分持平，以BOSS剩余血量、浩然归属判定胜负。2分和1分队伍将再次随机抽签和其余相同比分队伍进行晋级争夺。',
      '第一场·王陵争霸赛（20:00-20:30）',
      '参赛队伍入场时间:19:00',
      '比赛时间:20:00-20:30',
      '比赛坐标：原版千年帝王陵坐标',
      '进入时间:20:00-20:15',
      '入场规则：20点整王陵开放进入，20点-20点15分之间可反复进入王陵,王陵内死亡后复活至王陵门口，20点14分59秒后无法进入王陵。',
      '',
      '比赛规则：仅开放王陵一层，王陵一层将刷新活动BOSS,优先击杀活动BOSS得1分，超时未击杀双方0分。',
      '帝王陵 狐狸洞',
      '胜负规则：BOSS死亡后浩然归属判定 （单角色造成伤害血量多的一方为浩然方）',
      '单角色造成伤害血量多的一方为浩然方可理解为：对BOSS造成伤害最高的玩家所属门派可立即拾取BOSS掉落。',
      '判定方式：BOSS死亡后掉落道具可立即拾取方判定胜利,掉落道具2分钟后所有玩家均可拾取,BOSS未击杀双方0分。',
      '狐狸洞 为例 进入限制时间：北京时间20点45分00 无法进入 （不要看小地图）',
      '玩家副本内死亡后浩然不会清除。',
      '比赛结束后所有参赛成员自动传送至长城以南准备进行20:30的狐狸洞争霸赛，需自行前往狐狸洞入口。',
      '',
      '第二场·狐狸洞争霸赛（20:30-21:00）',
      '比赛时间:20:30-21:00',
      '进入时间:20:30-20:45',
      '比赛坐标：原版千年狐狸洞坐标',
      '比赛规则:20:30整狐狸洞开放进入，20点30分-20点45分之间可反复进入狐狸洞，狐狸洞内死亡后复活至狐狸洞门口，20点44分59秒后无法进入狐狸洞。',
      '',
      '比赛规则：仅开狐狸洞一层，狐狸洞一层将刷新活动BOSS,优先击杀活动BOSS得1分，超时未击杀双方0分。',
      '帝王陵 狐狸洞',
      '胜负规则：BOSS死亡后浩然归属判定 （单角色造成伤害血量多的一方为浩然方）',
      '单角色造成伤害血量多的一方为浩然方可理解为：对BOSS造成伤害最高的玩家所属门派可立即拾取BOSS掉落。',
      '判定方式：BOSS死亡后掉落道具可立即拾取方判定胜利,掉落道具2分钟后所有玩家均可拾取,BOSS未击杀双方0分。',
      '狐狸洞 为例 进入限制时间：北京时间20点45分00 无法进入 （不要看小地图）',
      '玩家副本内死亡后浩然不会清除。',
      '',
      '第三场·侠忍之争争霸赛（21:00-21:30）',
      '比赛时间:21:00-21:30',
      '比赛坐标：长城以南-中央市场-门派战NPC传送进入',
      '报名方式：比赛当日参赛队伍门主在21点前前往 中央市场-门派战NPC处报名',
      '报名人： 当前门派门主 ',
      '进入方式：21点整门派成员点击 中央市场-门派战NPC传送进入(需门派成员点击传送进入',
      '比赛人数：共计 100 人，双方各 50 人',
      '侠忍比赛持续时间：30 分钟 ',
      '进入战场分配规则：参赛2个门派成员传送进入战场后会自动归属在所属门派一方 侠客或忍者',
      '侠忍之争比赛规则：',
      '1、地图内共有五个资源点，通过占领旗帜可增加阵营分增长速度',
      '2、占领旗帜期间受到攻击将被打断，占领“铁匠铺的旗帜”后门派复活点将转移至此地',
      '3、点击“战场信息”可查看自身排行，可通过击杀玩家、输出伤害、占领旗帜取得排名',
      '4、胜负判定：比赛结束后，分数高的门派将获胜。',
      "二.晋级赛（16晋8）（8晋4）",
      "无积分 胜者晋级，败者淘汰 不记积分",
      '三.冠亚季军',
      '4强胜者进入冠亚军争夺赛',
      '4强败者进入季军争夺赛'
    ],
  },
  {
    id: 'match-rule',
    title: '比赛规则',
    content: [
      '1. 争霸赛正式服务器仅赛事当日 19:00-22:00 开放，其余时间无法登录。',
      '2. 比赛当日19:00开放服务器参赛队伍入场，非参赛队伍请勿进入。',
      '3. 所有比赛账号统一标配：太极全套装备+二层全套武功，全员公平起步。',
      '4. 参赛队伍预创建好门派，参赛人员进入对应门派 进入后请勿退出门派，转移门主。',
      '5.19点-20点期间参赛队伍可在长城以南自由活动。',
      '6.我们将为参赛队伍提供争霸赛测试区服用于团队磨合。',
      '7.千年争霸赛将提供：安卓版，IOS版，PC电脑端供参赛成员自由选择',
      '8.严禁使用违规软件等工具，若有发现将进行严肃处理',
    ],
  },
  {
    id: 'promotion-rule',
    title: '晋级规则',
    content: [
      '1.海选赛：十六强争夺每场比赛结束后0分队伍直接淘汰,3分队伍晋级',
      '2.晋级赛：八强争夺胜者晋级败者淘汰',
      '千年争霸赛-晋级赛规则 ',
      '第一场 门派战（侠忍之争）',
      '时间：20:00-20:30 ',
      '规则：同海选相同',
      '',
      '第二场 狐狸洞',
      '时间：20:30-21:00',
      '规则：BOSS血量降低20% 相比海选阶段 其余不变',
      '',
      '第三场 帝王陵',
      '时间：21:00-21:30',
      '规则：BOSS血量降低20% 相比海选阶段 其余不变',
      '',
      '晋级赛开始时间：10月8日起 每天一场 ',
      '晋级赛分组规则：小程序随机抽签分组',
      '晋级赛胜出规则：胜者晋级败者淘汰，若出现平局1分比1分情况下将加开一场门派战定胜负',
      '',
      '一.四强比赛场次时间：',
      '第一场门派战：20点-20点30',
      '（需双方门主20点前往中央市场门派战NPC报名）',
      '第二场狐狸洞：20点30-21点',
      '第三场 帝王陵：21点-21点30',
      '加时赛：第四场门派战：21点30-22点',
      '（需双方门主20点45分-21点30分前往中央广场门派战NPC报名）',
      '加时赛：第五场狐狸洞：22点-22点30',
      '加时赛：第六场帝王陵：22点30-23点',
      '二.四强比赛战场：',
      '小组1 战场一， 小组2，战场二',
      '季军赛 比赛战场  战场二 （会再次发放新账号）',
      '冠亚军赛 比赛战场 战场一（会再次发放新账号）',
      '三.四强半决赛：10 月 27 日（周二）',
      '四.季军争夺战 & 冠亚军总决赛：10 月 30 日（周五）',
      '五.赛制说明',
      '四强+冠亚季军争夺战 ：抢 3赛制',
      '对局地图顺序：门派战→狐狸洞→帝王陵→门派战→狐狸洞，按此顺序循环，直至分出胜负单场胜方积 1 分，先斩获 3 分即为系列赛胜者。',
      '药品规则：1钱币免费购买（每场限购1次，不保留单场剩余药品）',
      'BOSS掉落：生药 原为 白酒'
    ],
  },
]
